import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useTranslation } from "react-i18next";

export default function AdminCustomers() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [news, setNews] = useState([]);
  const [otpOn, setOtpOn] = useState(false);
  useEffect(() => {
    api.get("/merchant/customers").then(({ data }) => setItems(data));
    api.get("/merchant/customers/newsletter").then(({ data }) => setNews(data.items || data || [])).catch(() => setNews([]));
    api.get("/merchant/config/firebase-otp").then(({ data }) => setOtpOn(Boolean(data.enabled))).catch(() => setOtpOn(false));
  }, []);
  return (
    <div className="space-y-6">
      <h1 className="font-display text-3xl font-bold text-slate-900">{t("customers.title")}</h1>
      <Tabs defaultValue="customers">
        <TabsList data-testid="customers-tabs">
          <TabsTrigger value="customers" data-testid="customers-tab-list">{t("customers.tabCustomers", { defaultValue: "Customers" })}</TabsTrigger>
          <TabsTrigger value="newsletter" data-testid="customers-tab-newsletter">{t("customers.tabNewsletter", { defaultValue: "Newsletter Signups" })}</TabsTrigger>
        </TabsList>
        <TabsContent value="customers">
          <Card className="p-0 overflow-hidden border-slate-200/70">
            {items.length === 0 ? (
              <div className="p-12 text-center text-slate-500 text-sm">{t("customers.empty")}</div>
            ) : (
              <div className="divide-y divide-slate-100">
                {items.map((c) => (
                  <div key={c.id} className="p-4 flex items-center justify-between" data-testid={`customer-${c.email}`}>
                    <div>
                      <div className="font-semibold text-slate-900">{c.name}</div>
                      <div className="text-xs text-slate-500">{c.email}</div>
                      {otpOn ? (
                        <div className="text-xs text-slate-500 font-mono-nums" data-testid={`customer-phone-${c.email}`}>
                          {t("customers.phone", { defaultValue: "Phone" })}: {c.phone || "—"}
                        </div>
                      ) : null}
                    </div>
                    <div className="text-xs text-slate-500 font-mono-nums">{t("customers.joined", { date: new Date(c.created_at).toLocaleDateString("en-IN") })}</div>
                  </div>
                ))}
              </div>
            )}
          </Card>
        </TabsContent>
        <TabsContent value="newsletter">
          <Card className="p-0 overflow-hidden border-slate-200/70" data-testid="newsletter-signups">
            {news.length === 0 ? (
              <div className="p-12 text-center text-slate-500 text-sm">{t("customers.newsletterEmpty", { defaultValue: "No newsletter signups yet." })}</div>
            ) : (
              <div className="divide-y divide-slate-100">
                {news.map((n) => (
                  <div key={n.id} className="p-4 flex items-center justify-between" data-testid={`newsletter-${n.email}`}>
                    <div className="font-medium text-slate-900">{n.email}</div>
                    <div className="text-xs text-slate-500 font-mono-nums">{n.created_at ? new Date(n.created_at).toLocaleString("en-IN") : ""}</div>
                  </div>
                ))}
              </div>
            )}
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
